/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(theme => ({
  root: {
    fontSize: Tokens.spacing['$sp-4'],
    marginLeft: Tokens.spacing['$sp-6'],
    '& .Mui-selected:hover': {
      color: theme.palette.text.primary,
    },
    '& .Mui-selected': {
      color: theme.palette.text.primary,
    },
  },
  card: {
    height: 'auto',
  },
  loader: {
    textAlign: 'center',
    alignItems: 'center',
    padding: Tokens.spacing['$sp-3']
  },
  policyRoot: {
    margin: Tokens.spacing['$sp-10'],
    marginTop: Tokens.spacing['$sp-4']
  },
  deleteIcon: {
    cursor: 'pointer',
  },
}));